import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");

export const errMsg = (e) => e?.response?.data?.detail || "Si è verificato un errore";

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, extra = {}) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${url}`, data, headers: { Authorization: `Bearer ${token}` }, ...extra });
      return res.data;
    },
    [getToken]
  );
}

export const trackEvent = (slug, type, target = "") =>
  axios.post(`${API}/public/cards/${slug}/event`, { type, target }).catch(() => {});
